/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ChartPhrases {
    angular.module("meevo.plugins.chartPhrases", []);
}
